export default {"src":"/_next/static/media/enerflo-platform-icon-simplified-financing.ccf5a8ba.svg","height":160,"width":160};